var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-features"},_vm._l((_vm.features_list),function(feature,index){return _c('div',{key:index,staticClass:"feature-item"},[_c('img',{attrs:{"src":require(`@/assets/images/main/landing_mobile/features/${feature}.svg`),"alt":"feature-icon"}}),_c('p',[_vm._v(_vm._s(_vm.$t(feature)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }